module.exports = __webpack_public_path__ + "src/img/up.cc5cdc7a.svg";